<template>
    <div class="outer-content">
        <div class="inner-content">

            <div class="upper-panel">
                <div class="header" v-html="T('Generate_Session_Code')"></div>
            </div>

            <div class="rectangle-container w-100 position-absolute d-flex justify-content-center align-items-center">
                <div class="rectangle d-flex justify-content-center align-items-center">{{ game.id }}</div>
            </div>
            <div class="copy-code-container w-100 position-absolute d-flex justify-content-around">
                <div @click="copyCode" class="copy-code-button" v-html="T('Copy_1')"></div>
                <div @click="emailCode" class="copy-code-button" v-html="T('Email_1')"></div>
            </div>
            <div class="button-container w-100 position-absolute d-flex justify-content-center align-items-center">
                <StartButton @click="$emit('start-game', game.id)">
                </StartButton>
            </div>

            <div class="shared-back-button" v-html="T('button_back')" @click="$emit('back')">
            </div>            
                        
        </div>
    </div>
</template>
  
<script lang="ts">
import Vue, { PropType } from 'vue';
import Game from '../../../shared_fca/game';
import { T } from '@/App.vue';
import StartButton from '../components/Simple/StartButton.vue';

export default Vue.extend({
    name: 'SessionCode',
    components: {
        StartButton
    },
    props: {
        game: Object as PropType<Game>,
    },
    methods: {
        copyCode() {

            navigator.clipboard.writeText(window.location.href).then(() => {
                Vue.$toast.open({ message: T('copy_code_notification'), type: "info" });
            }).catch(()=>{
                Vue.$toast.open({ message: T('copy_code_error'), type: "error" });
            })

        },
        emailCode() {

            //The PIN is ' + this.game.id
            window.open('mailto:?subject=' + T('email_subject_line') + '&body=' + T('email_body').replace("@@@", location.href).replace("###", this.game.id));

        },
        T(key: string): string {
            return T(key);
        }
    }
});
</script>
  
  <!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.rectangle-container {
    top: 303px;
}

.copy-code-container {
    top: 522px;
    color: #636252;
    font-family: Rubik;
    font-size: 38px;
    font-weight: bold;
    letter-spacing: 0;
    line-height: 46px;
    text-align: center;
}

.copy-code-button {
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 38px;
    letter-spacing: 0;
    line-height: 46px;
    text-align: center;
    pointer-events: unset;
    cursor: pointer;
}

.rectangle {
    box-sizing: border-box;
    height: 195px;
    width: 840px;
    border: 12px solid #4A4A4A;
    border-radius: 32px;
    color: #9A9A9A;
    font-family: Rubik;
    font-size: 180px;
    font-weight: 900;
    letter-spacing: 0;
    line-height: 213px;
    text-align: center;
    user-select: all;
    background-color: white;
}

.button-container {
    top: 670px;
}

.button-start {
    height: 88px;
    width: 266px;
    border-radius: 8px;
    background-color: #B53D30;
    color: #FFFFFF;
    font-family: Rubik;
    font-size: 48px;
    font-weight: bold;
    letter-spacing: 0.03px;
    line-height: 57px;
    text-align: center;
    pointer-events: unset;
    cursor: pointer;
}
</style>
  